module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/4-a0aed7f8fd35a84e741ade324e6611f1.jpg";